import MaterialTable from "material-table";
import React, { forwardRef, memo, useMemo } from "react";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import RefreshIcon from "@material-ui/icons/Refresh";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} color="action" />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => (
    <Edit {...props} ref={ref} color="action" />
  )),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const Table = ({
  title,
  languageChips,
  columns,
  refetch,
  data,
  tableActions = [],
  ...props
}) => {
  const options = useMemo(
    () => ({
      actionsColumnIndex: columns.length,
      pageSize: 10,
      rowStyle: {
        fontFamily: "Roboto",
        fontSize: 14,
      },
      ...props.options,
    }),
    [columns, props.options]
  );
  const tableTitle = useMemo(
    () => (
      <Grid
        container
        direction="column"
        p={2}
        spacing={1}
        style={{ paddingTop: "1rem" }}
      >
        <Grid item>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography variant="h6">
                {title} ({data.length})
              </Typography>
            </Grid>
            <Grid item>
              {typeof refetch === "function" && (
                <Tooltip title="Refresh">
                  <IconButton size="small" onClick={refetch}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
            {tableActions.map((action, i) => (
              <Grid key={i} item>
                {action}
              </Grid>
            ))}
          </Grid>
        </Grid>
        {languageChips ? <Grid item>{languageChips}</Grid> : null}
      </Grid>
    ),
    [refetch, title, data, tableActions, languageChips]
  );
  return (
    <MaterialTable
      {...props}
      columns={columns}
      data={data}
      icons={{
        ...tableIcons,
        ...props.tableIcons,
      }}
      options={options}
      title={tableTitle}
    />
  );
};

export default memo(Table);
